export default __webpack_public_path__ + "static/media/arrow_forward_black-2@2x.d8aafef3.png";